import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  "pt-BR": {
    translation: {
      language: "Idioma",
      spanish: "Espanhol",
      portuguese: "Português",
      follow: "Siga-nos nas redes sociais",
      select: "Selecionar",
    },
  },
  es: {
    translation: {
      language: "Idioma",
      spanish: "Español",
      portuguese: "Portugues",
      follow: "Síguenos en redes",
      select: "Selecciona",
    },
  },
  "es-AR": {
    translation: {
      language: "Idioma",
      spanish: "Español",
      portuguese: "Portugues",
      follow: "Seguinos en redes",
      select: "Selecciona",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("lang") || "es-AR",
  fallbackLng: "pt-BR",
  ns: ["translation"],
  defaultNS: "translation",
  interpolation: { escapeValue: false },
});

export default i18n;
